import { render, staticRenderFns } from "./NotificationSettingsStockwatchGrid.vue?vue&type=template&id=f495b5d0&"
import script from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsStockwatchGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports